import React, {useEffect, useState} from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import theme from '../../../theme/theme'
import Header from '../../../components/globle/header'
import Button from '../../../components/globle/button'
import AuthorDetails from '../editAuthor/authorDetails'
import { useParams } from 'react-router-dom';
import api from "../../../services/api";


const EditAuthor = ({ isAuthenticated }) => {
    const [section, setSection] = useState(1);
    const [saveClick, setSaveClick] = useState(false);

    return (
        <div>
            <div
                style={{
                    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)"
                }}
            >
                <Header isAuthenticated={isAuthenticated} />
            </div>
            <div
                className='top-cont'
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "20px",
                    padding: "20px 0px"
                }}
            >
                <Button
                    className={'btn-dark-500'}
                    onClick={()=>setSaveClick(!saveClick)}
                    title={"Save"}
                />
            </div>
            <div
               className={'border-bottom-2 border-bottom-solid border-dark-400'}
            >



                <div className='top-cont'>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "end",
                            justifyContent: "flex-start",
                            gap: "90px",
                        }}
                    >


                        <div
                            onClick={() => setSection(1)}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                gap: "20px"
                            }}
                        >
                            <span
                                style={{
                                    fontFamily: "semiBold",
                                    fontSize: "20px",
                                    color: section === 1 ? theme.primary : "#CDCDCD"
                                }}
                            >Author Detail</span>

                            <div
                                style={{
                                    width: "100%",
                                    height: "4px",
                                    background: theme.primary,
                                    borderRadius: "20px",
                                    visibility: section === 1 ? "visible" : "hidden"
                                }}
                            ></div>
                        </div>



                    </div>
                </div>
            </div>
            {
                section === 1 ?
                    <div>
                       <AuthorDetails saveClick={saveClick} setSaveClick={setSaveClick}/>
                    </div>
                    :
                    <div>
                        1
                    </div>
            }


        </div>
    )
}

export default EditAuthor
